<template>
  <transition
    v-bind:css="false"
    v-on:enter="enter"
    v-on:leave="leave"
    appear
  >
    <div class="modal" @click.self="handleClose">
      <div class="inner">
        <button class="close-button" @click="handleClose"><img :src="require('../../assets/images/icon-close.svg')" /></button>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
  import { TweenMax, Power4 } from "gsap";

  export default {
    name: "modal",

    components: {
    },
    methods: {
      enter(el) {
        TweenMax.fromTo(
          el,
          0.5,
          {
            alpha: 0
          },
          {
            alpha: 1,
            ease: Power4.easeOut
          }
        );
      },
      leave(el, done) {
        TweenMax.to(el, 0.5, {
          alpha: 0,
          ease: Power4.easeOut,
          onComplete: done
        });
      },
      handleClose() {
        this.$router.push({path: '/properties',query: this.$store.state.search.query})
      }
    }
  };
</script>

<style lang="scss" scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: fade-out(black, 0.5);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    z-index: 2000;
    overflow: scroll;
  }

  .inner {
    background-color: $white;
    width: 100%;
    max-width: 1200px;
    position: relative;
    margin: 3em;
    padding: 2em;
  }

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    border: 0;
    height: 40px;
    width: 40px;
    background-color: darken($white, 5%);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    img {
      width: 12px;
      height: 12px;
      opacity: .5;
    }

    &:hover {
      img {
        opacity: 1;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .modal {
      .inner {
        margin: 0;
      }
    }
  }
</style>
